import React, { useState } from 'react';
import Button from '@material-ui/core/Button';

import ConfirmDialog from '../modules/Whatsapp/components/ConfirmDialog';

// Кнопка удаления: сама ничего не удаляет, а открывает окно системы (то же, что в разделе
// рассылок) с пояснением, что именно будет удалено. Удаление выполняет onConfirm.
function ConfirmDeleteButton({ label, title, text, confirmLabel, onConfirm }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outlined" color="secondary" onClick={() => setOpen(true)}>
        {label}
      </Button>
      <ConfirmDialog
        open={open}
        title={title}
        text={text}
        confirmLabel={confirmLabel}
        confirmColor="secondary"
        onConfirm={() => {
          setOpen(false);
          onConfirm();
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

export default ConfirmDeleteButton;
